var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "empty" }, [_vm._v("暂无图片!")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }